// Meta browser cookies (_fbp / _fbc) set by the Facebook Pixel. They are
// forwarded with the lead payload so the server side (Meta CAPI) can match
// the conversion back to the same browser session.
function readCookie(name: string): string {
  if (typeof document === 'undefined') return ''
  const match = document.cookie.match(
    new RegExp(`(?:^|; )${name.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')}=([^;]*)`),
  )
  return match ? decodeURIComponent(match[1]) : ''
}

export function getMetaCookies(): { fbp: string; fbc: string } {
  return {
    fbp: readCookie('_fbp'),
    fbc: readCookie('_fbc'),
  }
}
